import { MUITab } from "@abb/arcadia-ui-react"
import { useHashTab } from "../../../hooks/useHashTab"
import { RoleRequests } from "./role_requests_tab/RoleRequests"

const ROLE_REQUESTS_TAB_ID = "role-requests"

export function RoleRequestsContainer() {
  const { activeTab, handleTabChange } = useHashTab(ROLE_REQUESTS_TAB_ID)

  return (
    <div>
      <MUITab
        tabItems={[{ id: ROLE_REQUESTS_TAB_ID, label: "Role Requests" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === ROLE_REQUESTS_TAB_ID && <RoleRequests />}
    </div>
  )
}
